import React from "react";
import "../styles/FeesPayment.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Fees_Payment from "../Assets/Pdfs/Fees_Payment.pdf";

export default function FeesPayment() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="fees-payment-page">
            <section className="fees-payment-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Fees & Payment
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Fees_Payment}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download link */}
                <p className="pdf-download">
                    <a
                        href={Fees_Payment}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Fees & Payment Policy
                    </a>
                </p>
            </section>

            <footer className="fees-payment-footer">
                <p>Thank you for following the institution’s fee and payment guidelines.</p>
            </footer>
        </div>
    );
}
